import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UserDAO } from '../../core/services/dao/userDAO';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UploadDAO } from '../../core/services/dao/uploadDAO';
import * as FileSaver from 'file-saver';
import { PortalService } from './portal-service';
import { Subscription } from 'rxjs';
import { ApiHelper } from '../../core/services/apiHelper';
import { AuthService } from '../../core/services/auth.service';
import { ContainsSubscriptions } from '../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../core/pure-functions/rx-helper';
import { ConstantMan } from '../../core/services/constantMan';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
})
export class PortalComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  canAccessAdmin = false;
  busy: Subscription;
  busySubscription: Subscription;
  charterParams = { status: 'lead' };
  subs: Subscription[] = [];

  constructor(
    private userDAO: UserDAO,
    private uploadDAO: UploadDAO,
    private apiHelper: ApiHelper,
    private cd: ChangeDetectorRef,
  ) {
    const currentUser = this.userDAO.getCurrentUser();

    this.busySubscription = this.apiHelper.busyChange$.subscribe((busy) => {
      this.busy = busy.subscribe();
    });
  }

  ngOnInit() {
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    if (this.busy) {
      this.busy.unsubscribe();
    }
    if (this.busySubscription) {
      this.busySubscription.unsubscribe();
    }
    unsubscribeFromAll(this.subs);
  }

  downloadICA() {
    this.uploadDAO.downloadFile('ica.pdf').subscribe(
      (result) => {
        let file = new File([result], 'ica.pdf');
        // FileSaver.saveAs(file, 'ica.pdf');
      },
      (err) => {
        console.error(err);
      },
    );
  }

  openSupport() {
    window.open(
      'https://docs.google.com/forms/d/e/1FAIpQLSch6KYZFBS94S5VNFnN61Adb8XP9AX8nkNp9SKIaAukh_-F-Q/viewform?usp=sf_link',
    );
  }
}
